import { useState } from 'react';

const METHODOLOGY_ITEMS = [
  {
    question: '¿Como se cuentan las ordenes?',
    answer: `Pasteles, panes, merchant, especiales = 1 orden = 1 unidad. Roscas = unidades vendidas (1 pedido de 5 roscas = 5). Total = suma de todo.`,
  },
  {
    question: '¿Como se calcula el promedio por dia?',
    answer: `Total ordenes ÷ dias en el rango (incluye dias con 0).`,
  },
  {
    question: '¿Como funciona la comparacion de periodos?',
    answer: `El % compara el periodo actual con el anterior de igual duracion. Formula: (actual - anterior) / anterior × 100.`,
  },
  {
    question: '¿Como se detectan los picos?',
    answer: `Pico = dia con 2x+ del promedio. Periodos pico = dias con 1.5x+ agrupados si son consecutivos (max 2 dias de separacion).`,
  },
  {
    question: '¿Que significa En Linea vs En Tienda?',
    answer: `Con cajero = En Tienda. Sin cajero = En Linea.`,
  },
  {
    question: '¿Que son las alertas de dias festivos?',
    answer: `El sistema revisa los proximos 14 dias contra 15 fechas clave. Muestra ordenes del ano pasado para esas fechas.`,
  },
];

const FAQ_ITEMS = [
  {
    question: '¿Puedo hacer clic en todo?',
    answer: `¡Sí! Esta página es solo para ver información.

Puedes hacer clic en cualquier botón, filtro o gráfica. Nada de lo que hagas aquí borra o cambia tus órdenes.

Es como ver fotos en tu teléfono — puedes verlas todas, pero no se borran por verlas.`,
  },
  {
    question: '¿De dónde salen estos números?',
    answer: `Los números vienen de tus órdenes reales.

Cada vez que alguien hace una orden de pastel, rosca, pan, etc., el sistema la cuenta automáticamente. No tienes que hacer nada especial.`,
  },
  {
    question: '¿Qué son los tipos de orden?',
    answer: `• **Pasteles**: Pedidos de pasteles
• **Roscas**: Pedidos de roscas de reyes
• **Panes**: Pedidos de pan
• **Merchant**: Pedidos de negocios/mayoreo
• **Especiales**: Otros pedidos especiales
• **Todos**: Todo junto`,
  },
  {
    question: '¿Qué significa el porcentaje verde o rojo?',
    answer: `**Verde (+)** = Subió. Hay más órdenes que antes.

**Rojo (-)** = Bajó. Hay menos órdenes que antes.

Por ejemplo: **+25%** quiere decir que tienes 25% más órdenes comparado con el período anterior.`,
  },
  {
    question: '¿Qué hacen los botones de fechas?',
    answer: `Cambian qué días ves en las gráficas:

• **7D**: La última semana
• **30D**: El último mes
• **90D**: Los últimos 3 meses
• **1Y**: El último año
• **All**: Todo desde el principio
• **Personalizado**: Tú eliges las fechas`,
  },
  {
    question: '¿Cómo veo los datos más nuevos?',
    answer: `Dale clic al botón **"Actualizar"** arriba a la derecha.

La página no se actualiza sola mientras la tienes abierta, así que si quieres ver órdenes nuevas, dale clic a ese botón.`,
  },
  {
    question: '¿Por qué hay días con cero?',
    answer: `Puede ser porque:

• La tienda estuvo cerrada ese día
• No hubo pedidos de ese tipo ese día
• Es normal, no es un error`,
  },
  {
    question: '¿Cómo veo solo una tienda?',
    answer: `**Dueños**: Usa el selector de tienda en la barra de arriba para elegir cuál tienda ver, o ve todas juntas.

**Gerentes**: Solo ves tu tienda asignada.`,
  },
  {
    question: '¿Qué son los números grandes arriba?',
    answer: `Son el total de pedidos en el tiempo que elegiste:

• **Total**: Todos los pedidos juntos
• **Pasteles**: Cuántos pasteles
• **Roscas**: Cuántas roscas
• **Panes**: Cuántos panes
• **Merchant**: Pedidos de negocios y cuánto dinero
• **Especiales**: Pedidos especiales`,
  },
];

/**
 * FAQ section explaining how analytics metrics are calculated
 */
export default function AnalyticsFAQ() {
  const [expandedKey, setExpandedKey] = useState(null);

  const toggleItem = (key) => {
    setExpandedKey(expandedKey === key ? null : key);
  };

  const renderItem = (item, key) => (
    <div
      key={key}
      className={`faq-item ${expandedKey === key ? 'expanded' : ''}`}
    >
      <button
        className="faq-question"
        onClick={() => toggleItem(key)}
        aria-expanded={expandedKey === key}
      >
        <span>{item.question}</span>
        <span className="faq-icon">{expandedKey === key ? '−' : '+'}</span>
      </button>
      {expandedKey === key && (
        <div className="faq-answer">
          {item.answer.split('\n').map((paragraph, pIndex) => {
            const parts = paragraph.split(/\*\*(.*?)\*\*/g);
            return (
              <p key={pIndex}>
                {parts.map((part, partIndex) =>
                  partIndex % 2 === 1 ? (
                    <strong key={partIndex}>{part}</strong>
                  ) : (
                    part
                  )
                )}
              </p>
            );
          })}
        </div>
      )}
    </div>
  );

  return (
    <div className="analytics-faq">
      <h3>Metodologia</h3>
      <div className="faq-list">
        {METHODOLOGY_ITEMS.map((item, index) => renderItem(item, `m-${index}`))}
      </div>

      <div className="methodology-divider" />

      <h3>Preguntas Frecuentes</h3>
      <div className="faq-list">
        {FAQ_ITEMS.map((item, index) => renderItem(item, `f-${index}`))}
      </div>
    </div>
  );
}
